import { when, set } from 'cerebral/operators'
import checkRegistrationUrl from '../actions/checkRegistrationUrl'
import redirect from 'cerebral-module-router/redirect'

export default [
  checkRegistrationUrl,
  {
    error: [redirect('/login')],
    success: [
      when('state:login.acceptedGDPR'),
      {
        true: [],
        false: [set('state:login.showGDPRDialog', true)]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/login/chains/validateRegistrationStep.js